// import { Visibility } from "@material-ui/icons";

export const columns = [
    { headerText: 'Model', key: 'model', dataType: 'string', readOnly: true, allowTooltips: false, width: '90', allowHiding: false, hidden: true, allowSorting: false },
    { headerText: 'Model', key: 'modelName', dataType: 'string', readOnly: true, allowTooltips: false, width: '90', template: '<a href="https://www.ruskin.com/model/${model}" style="color: #000;" target="_blank">${modelName}</a>' },
    { headerText: 'Material', key: 'material', dataType: 'string', readOnly: true, allowTooltips: false, width: '100' },
    { headerText: 'Frame Thick.', key: 'frmGauge', dataType: 'number', readOnly: true, allowTooltips: false, width: '90', formatter: FrameThickFormatter },
    { headerText: 'Louver Depth', key: 'depth', dataType: 'number', readOnly: true, allowTooltips: false, width: '90', formatter: FrameDepthFormatter },
    { headerText: 'Blade', key: 'bladeStyleDescription', dataType: 'string', allowTooltips: false, width: '200', readOnly: true },
    { headerText: 'Width (in)', key: 'selectedWidth', dataType: 'number', allowTooltips: false, width: '90', readOnly: true },
    { headerText: 'Height (in)', key: 'selectedHeight', dataType: 'number', allowTooltips: false, width: '90', readOnly: true },
    { headerText: 'Free Area (ft²)', key: 'freeArea', dataType: "number", allowTooltips: false, readOnly: true },
    { headerText: 'Free Area %', key: 'freeAreaPerc', dataType: 'number', allowTooltips: false, readOnly: true },
    { headerText: 'Free Area Vel (fpm)', key: 'freeAreaVelocity', dataType: 'number', allowTooltips: false, readOnly: true },
    { headerText: 'Pressure Drop (w.g.)', key: 'pressureDrop', dataType: 'number', allowTooltips: false, readOnly: true, width: '100' },
    { headerText: 'Beginning Water Pen.(fpm)', key: 'begWaterPen', dataType: 'number', allowTooltips: false, readOnly: true, width: '110', formatter: NotApplicableFormatter },
    { headerText: 'Water Pen. Safety Factor', key: 'waterPenSafFac', dataType: 'number', allowTooltips: false, readOnly: true, width: '90', formatter: NotApplicableFormatter },
    { headerText: 'Cost Index', key: 'costIndex', dataType: 'number', readOnly: true, width: '90' },
    { headerText: 'Class A 29 MPH Wind VEL (fpm)', key: 'lowWeather', dataType: 'number', readOnly: true, width: '90', formatter: NotApplicableFormatter },
    { headerText: 'Class A 50 MPH Wind VEL (fpm)', key: 'highWeather', dataType: 'number', readOnly: true, width: '90', formatter: NotApplicableFormatter },
    { headerText: 'Sect. Width', key: 'width', dataType: 'string', width: '90', allowTooltips: false, readOnly: true },
    { headerText: 'Sect. Height', key: 'height', dataType: 'string', width: '90', allowTooltips: false, readOnly: true },

];


export const fields = [{
    defaultValue: 1,
    maxLength: 5,
    maxValue: 99999,
    minValue: 1,
    name: 'quantity',
    required: true,
    type: 'numeric'
}, {
    defaultValue: null,
    maxLength: 15,
    name: 'tag'
}];

function FrameThickFormatter(val) {
    if (val < 1) {
        return val + "\"";
    }
    else {
        return val + "ga";
    }
}
function FrameDepthFormatter(val) {
    return val + "\"";
}
function NotApplicableFormatter(val) {
    if (val === null || val === 0) {
        val = 'N/A';
    }
    return val;
}
